import { render, staticRenderFns } from "./bet_slip.vue?vue&type=template&id=07aaca6c&"
import script from "./bet_slip.vue?vue&type=script&lang=js&"
export * from "./bet_slip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiBetslipHeader: require('/var/web/bet777.es/themes/dark/ui/Betslip/Header.vue').default,BetslipCalc: require('/var/web/bet777.es/components/betslip/calc.vue').default,UiBetslipSummary: require('/var/web/bet777.es/themes/dark/ui/Betslip/Summary.vue').default,BetbuilderSlip: require('/var/web/bet777.es/components/betbuilder/slip.vue').default,UiBetslipContainer: require('/var/web/bet777.es/themes/dark/ui/Betslip/Container.vue').default})
